import Overlay from './map/overlay'
class GlobalOverlayManager {
  constructor() {
    if (!GlobalOverlayManager.instance) {
      GlobalOverlayManager.instance = this;
      this.data = {
        overlays: {},
        googleMap: null,
      }
    }
    return GlobalOverlayManager.instance;
  }
  
  setMap(value) {
    this.data.googleMap = value
  }
  
  getMap() {
    return this.data.googleMap
  }
  
  async addOverlay(overlayId) {
    if (Object.hasOwn(this.data.overlays, overlayId)) {
      // We already retrieved this information.  Return it
      return this.data.overlays[overlayId];
    } else {
      // Go get the information we desire
      try {
        const request = new Request(window.routes.overlay_path(overlayId), { method: 'GET' });
        const response = await fetch(request);
        const json = await response.json();
        if (json.success) {
          this.data.overlays[overlayId] = new Overlay(JSON.parse(json.data).attributes);
          return this.data.overlays[overlayId];
        } else {
          return null;
        }
      } catch (error) {
        console.error('Error fetching overlay:', error);
        return null;
      }
    }
  }

  getOverlayShape(shapeId) {
    for(let key in this.data.overlays) {
      const shape = this.data.overlays[key].Shapes.find(shape => shape.Id === shapeId.replace(/^'|'$/g, ''));
      if (shape) {
        return shape;
      }
    }
    return null;
  }

  async getOverlayShapeFromOverlay(shapeId, overlayId) {
    if (overlayId in this.data.overlays) {
      const shape1 = this.data.overlays[overlayId].Shapes.find(shape => shape.Id === shapeId.replace(/^'|'$/g, ''));
      return shape1;
    } else {
      const overlay = await this.addOverlay(overlayId);
      if (overlay) {
        const shape2 = this.data.overlays[overlayId].Shapes.find(shape => shape.Id === shapeId.replace(/^'|'$/g, ''));
        return shape2;
      }
    }
    // Couldn't find the shape.
    return null;
  }

}

const instance = new GlobalOverlayManager();
Object.freeze(instance)
export default instance;
